import { User } from 'reducers/authReducer/authReducer.types';

const isSuperAdmin = (user: User): boolean => {
  return [
    'karlisba@gmail.com',
    'root',
    'naurisbabris@gmail.com',
    'nauris@babrisoftware.com',
    'nauris@mychoice.ca',
    'karlis@mychoice.ca',
  ].includes(user.email);
};

export default isSuperAdmin;
